import { Link } from "react-router-dom";
import { useEffect } from "react";

export default function Breadcrumbs({ items }) {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "breadcrumb-jsonld";
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: items.map((item, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: item.label,
        ...(item.to ? { item: `${window.location.origin}${item.to}` } : {}),
      })),
    });
    document.head.appendChild(script);
    return () => script.remove();
  }, [items]);

  return (
    <nav aria-label="Breadcrumb" className="border-b border-platinum bg-paper" data-testid="breadcrumbs">
      <div className="container-x py-3">
        <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 font-sub text-xs tracking-wide text-slate">
          {items.map((item, i) => (
            <li key={item.label} className="flex items-center gap-2">
              {i > 0 && <span aria-hidden="true" className="text-gold-deep">/</span>}
              {item.to && i < items.length - 1 ? (
                <Link to={item.to} className="transition-colors hover:text-gold-deep">
                  {item.label}
                </Link>
              ) : (
                <span aria-current="page" className="font-semibold text-navy">
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}
